import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import template from './contact-information.html';
import { MySiteRestService } from '@nuskin/my-site-api';
import { MySiteApp } from '../../my-site-app';
import { nuskin } from '@nuskin/ns-util'

/**
 * @customElement
 * @polymer
 */

export class ContactInformation extends PolymerElement {

    constructor() {
        super();
        this.emailRegex = /.+@.+\.\w+/g;
        this.phoneRegex = /^[^a-zA-Z]*$/;
        this.profilePhoto = '';
        this.disableImgUploader = false;
        this.data = {}; // form data
        // eslint-disable-next-line no-undef
        let context = translationService.getCurrentContext();
        // eslint-disable-next-line no-undef
        this.content = translationService.getTranslations(context);

        this.eventsToListenTo = [
            'value-changed',
            'valid-changed',
            'invalid-changed'
        ];

        this.formFields = [];

        // pass save method to form wrapper
        this.parentNode.saveForm = this.save();
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'contact-information';
    }

    ready() {
        super.ready();
        this.getFormFields();
        this.formFields.forEach(field => {
            this.eventsToListenTo.forEach(event => {
                field.addEventListener(event, this.parentNode.formChanged);
                field.addEventListener('focused-changed', this.parentNode.formTouched);
            });
        });
        this.mySite = document.querySelector(MySiteApp.is);
        this.mySite.addEventListener('my-site-data-changed', this._subscribeToMySiteDataChanges.bind(this));

        this.$.email.addEventListener('value-changed', this._handleEmailChange.bind(this));
        this.$.phone.addEventListener('value-changed', this._handlePhoneChange.bind(this));
        this.$.firstName.addEventListener('value-changed', this._handleFirstNameChange.bind(this));
        this.$.lastName.addEventListener('value-changed', this._handleLastNameChange.bind(this));
        this.$.displayName.addEventListener('value-changed', this._handleDisplayNameChange.bind(this));
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.formFields.forEach(field => {
            this.eventsToListenTo.forEach(event => {
                field.removeEventListener(event, this.parentNode.formChanged);
                field.removeEventListener('focused-changed', this.parentNode.formTouched);
            });
        });
        this.mySite.removeEventListener('my-site-data-changed', this._subscribeToMySiteDataChanges.bind(this));

        this.$.email.removeEventListener('value-changed', this._handleEmailChange.bind(this));
        this.$.phone.removeEventListener('value-changed', this._handlePhoneChange.bind(this));
        this.$.firstName.removeEventListener('value-changed', this._handleFirstNameChange.bind(this));
        this.$.lastName.removeEventListener('value-changed', this._handleLastNameChange.bind(this));
        this.$.displayName.removeEventListener('value-changed', this._handleDisplayNameChange.bind(this));
    }

    _subscribeToMySiteDataChanges() {
        if(this.mySite.currentForm !== ContactInformation.is) return;
        this.set('data', this.mySite.mySiteData);
        this.parentNode.formChanged();
    }

    _handleEmailChange(e) {
        this.parentNode.updateAndNotify(getEventValue(e), false, false, 'email', true);
    }

    _handlePhoneChange(e) {
        this.parentNode.updateAndNotify(getEventValue(e), false, false, 'phone', true);
    }

    _handleFirstNameChange(e) {
        this.parentNode.updateAndNotify(getEventValue(e), false, false, 'firstName');
    }

    _handleLastNameChange(e) {
        this.parentNode.updateAndNotify(getEventValue(e), false, false, 'lastName');
    }

    _handleDisplayNameChange(e) {
        this.parentNode.updateAndNotify(getEventValue(e), false, false, 'displayName');
    }

    _updateDisplayName (familyName, individualName) {
        const familyFirst = this.content.contactInformationFormFamilyFirst;

        return familyFirst
            ? (familyName + ' ' + individualName)
            : (individualName + ' ' + familyName);
    }

    // must be present to allow `form-wrapper` save the form
    save() {
        let that = this;
        return function() {
            const familyName = that.$.lastName.value.trim();
            const individualName = that.$.firstName.value.trim();
            const displayName = that.$.displayName.value.trim() || that._updateDisplayName(familyName, individualName);

            let data = {
                firstName: individualName,
                lastName: familyName,
                displayName: displayName,
                phone: that.$.phone.value,
                email: that.$.email.value
            };

            // GA
            try {
                nuskin.events.publish(nuskin.events.mySite.SECTION_DATA_UPDATE, {
                    mySite: {
                        section: ContactInformation.is,
                        changed: data
                    }
                });
            } catch(err) {
                console.error(err)
            }

            return MySiteRestService.updateSponsorData(data);
        }
    }

    // must be present for form validation check
    getFormFields() {
        this.formFields = [
            this.$.firstName,
            this.$.lastName,
            this.$.displayName,
            this.$.phone,
            this.$.email
        ];
    }
}

function getEventValue(e) {
    return e.detail.value;
}

window.customElements.define(ContactInformation.is, ContactInformation);
